<template>
    <v-dialog v-model="show" scrollable max-width="400px">
      <v-card>
        <v-card-title>Freigegebene Nutzer</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <template v-for="(user, index) in users">
            <v-divider v-if="index!=0" :key="'d'+index" :inset="false"></v-divider>

            <v-list-item :key="index">
              <v-list-item-content>
                <v-list-item-title style="flex: unset !important">
                  <v-icon color="red" @click="removeAuthorizedUser(user.userId)">delete</v-icon>
                  {{user.firstName}} {{user.lastName}}
                </v-list-item-title>
                
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="show = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import processModelingService from "./process-modeling-service";

export default {
  props: {
    value: Boolean,
    uuid: {
      required: true,
      type: String
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    show: function (show) {
      if(show){
        processModelingService.retrieveSharedUsers(this.uuid).then(result=>{
          this.users=result.data;
        });
      }
    },
  },
  data() {
    return {
      users: []
    };
  },
  methods: {
    removeAuthorizedUser(user){
      processModelingService.removeSharedUser(this.uuid, user).then(result => {
        this.show = false;
      })
    }
  }
};
</script>